module.exports = __webpack_public_path__ + "img/messages.6014c6de.png";